module.exports = "<div\n  class=\"overlay auto-animate\"\n  ng-style=\"{ backgroundColor: color }\"\n  ng-transclude\n></div>\n"